module.exports = __webpack_public_path__ + "img/plus.16a2254f.svg";